import React from 'react';
import { Printer, Wifi, Bluetooth, CloudUpload, CircleCheck } from 'lucide-react';
import { PublicSection, Reveal } from '@/components/public';
import { HARDWARE } from '@/config/integrations';

const ICONS = {
  epson: [Wifi, Bluetooth],
  'star-micronics': [CloudUpload, Printer],
};

export default function HardwareSection() {
  return (
    <PublicSection
      id="thermal-printers"
      testId="hardware-section"
      variant="alt"
      eyebrow="Thermal Hardware Printing"
      title="Compatible Kitchen & Receipt Thermal Printers"
      description="Eliminate tablet watching. Send online orders instantly to your counter or kitchen printing line."
      padTop="pt-16 md:pt-20"
      padBottom="pb-16 md:pb-20"
    >
      <div className="grid gap-6 md:grid-cols-2">
        {HARDWARE.map((hw, i) => {
          const [IconA, IconB] = ICONS[hw.id];
          return (
            <Reveal key={hw.id} delay={i * 0.08}>
              <div
                data-testid={`hardware-card-${hw.id}`}
                className="h-full bg-background border border-border p-6 md:p-8 transition-transform duration-200 hover:-translate-y-1"
              >
                <div className="flex items-center justify-between gap-4 mb-5">
                  <div className="flex items-center gap-2.5">
                    <span className="inline-flex w-10 h-10 items-center justify-center bg-primary/10 text-primary">
                      <IconA className="w-5 h-5" strokeWidth={2.25} />
                    </span>
                    <span className="inline-flex w-10 h-10 items-center justify-center bg-primary/10 text-primary">
                      <IconB className="w-5 h-5" strokeWidth={2.25} />
                    </span>
                  </div>
                  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full border border-slate-500/30 bg-slate-500/10 text-slate-600 dark:text-slate-300 text-[11px] font-bold uppercase tracking-wide">
                    Supported Hardware
                  </span>
                </div>

                <h3 className="text-xl md:text-2xl font-heading font-black tracking-tight text-foreground">
                  {hw.name}
                </h3>
                <p className="mt-1 text-xs font-semibold uppercase tracking-[0.15em] text-primary">{hw.badge}</p>

                <p className="mt-4 text-sm md:text-base text-muted-foreground leading-relaxed">{hw.details}</p>

                <div className="mt-5 flex items-start gap-2.5 bg-emerald-500/10 border border-emerald-500/25 px-4 py-3">
                  <CircleCheck className="w-4 h-4 mt-0.5 shrink-0 text-emerald-600 dark:text-emerald-400" strokeWidth={2.5} />
                  <p className="text-sm text-foreground/85 leading-relaxed">
                    <span className="font-semibold">Key benefit:</span> {hw.benefit}
                  </p>
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </PublicSection>
  );
}
